module.exports = __webpack_public_path__ + "static/media/online-visit-image-modal.ca5dbaae.png";